<template>
    <i class="i-ph-caret-right"/>
    <targeting-router-link class="crumb" :to="INVOICE_JOURNAL">
        <i class="i-ph-files-fill"/>Fakturajournal
    </targeting-router-link>
    <i class="i-ph-caret-right"/>
    <div class="crumb truncate line-clamp-1">
        <i class="i-ph-files-fill"/>
        <div>{{ invoice?.invoiceNo }}</div>
    </div>
</template>

<script setup lang="ts">

import {INVOICE_JOURNAL} from '@/invoice'
import { TargetingRouterLink } from '@tritt/multipanel'
import {onMounted, ref} from 'vue'
import {getInvoice} from '@/invoice/invoice.service'
import {Invoice} from '@/invoice/types/Invoice'

const invoice = ref<Invoice>()

const props = defineProps({
    invoiceUuid: {
        type: String,
        required: true
    }
})


onMounted(async () => {
    invoice.value = await getInvoice(props.invoiceUuid)
})


</script>

<style scoped>

</style>